module.exports = __webpack_public_path__ + "img/image-error.b9c1c02f.jpg";